import React from 'react';
import { Drawer, Descriptions, Tag, Spin } from 'antd';
import { useQuery } from 'react-query';

import { getCarrierLog } from '@services/carrierLog';
import { handleAPIError } from '@services/base';

interface Props {
  logId: string | null;
  onClose: () => void;
}

const formatDateTime = (value?: string) => {
  if (!value) return '-';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleString();
};

const LogDetailDrawer: React.FC<Props> = ({ logId, onClose }) => {
  const { data, isFetching } = useQuery(
    ['carrier-log', logId],
    () => getCarrierLog(logId as string),
    {
      enabled: !!logId,
      onError: handleAPIError,
    },
  );

  const log = data?.log;

  return (
    <Drawer
      title="Log detail"
      placement="right"
      width={520}
      visible={!!logId}
      onClose={onClose}
      destroyOnClose
    >
      <Spin spinning={isFetching}>
        {log && (
          <>
            <Descriptions column={1} bordered size="small">
              <Descriptions.Item label="ID">{log._id}</Descriptions.Item>
              <Descriptions.Item label="Date">
                {formatDateTime(log.createdAt)}
              </Descriptions.Item>
              <Descriptions.Item label="Carrier">
                {log.carrier_name || log.carrier_id || '-'}
              </Descriptions.Item>
              <Descriptions.Item label="Action">
                {log.action || '-'}
              </Descriptions.Item>
              <Descriptions.Item label="Target">
                {log.target_id || '-'}
              </Descriptions.Item>
              <Descriptions.Item label="Success">
                <Tag color={log.success ? 'green' : 'red'}>
                  {log.success ? 'Success' : 'Failed'}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="User">
                {log.email || log.carrier_name || '-'}
              </Descriptions.Item>
              <Descriptions.Item label="Error">
                {log.error || '-'}
              </Descriptions.Item>
            </Descriptions>

            {log.payload && (
              <>
                <h4 style={{ marginTop: 16 }}>Payload</h4>
                <pre
                  style={{
                    background: '#f5f5f5',
                    padding: 12,
                    borderRadius: 8,
                    overflow: 'auto',
                    fontSize: 12,
                  }}
                >
                  {JSON.stringify(log.payload, null, 2)}
                </pre>
              </>
            )}
          </>
        )}
      </Spin>
    </Drawer>
  );
};

export default LogDetailDrawer;
